import React from 'react';
import moment from 'moment';

/**
 * @typedef {Urlaubsantrag} urlaubsantrag
 */
export default ({ urlaubsantrag }) => <span>{moment(urlaubsantrag.von).format('DD.MM.YY') + ' - ' + moment(urlaubsantrag.bis).format('DD.MM.YY')}</span>;
